import { fonts } from "../../../styles/fonts"
import { colors } from "../../../styles/colors"

const popoverWrapper: any = {
    background: colors.white,
    borderRadius: 5,
    boxShadow: "1px -3px 24px -3px rgba(0,0,0,0.20)",
    padding: "10px 0",
}

const selectOption: any = {
    color: colors.black,
    fontFamily: fonts.mediumFont,
    fontSize: 13,
    paddingLeft: 35,
    paddingBottom: 2,
    paddingRight: 32,
    paddingTop: 2
}

const selectLabel = {
    color: colors.blackishGrey,
    fontFamily: fonts.mediumFont,
    fontSize: 12,
    paddingLeft: 17,
    paddingBottom: 7
}

const tickIcon: any = {
    position: "absolute",
    left: 18,
    top: 6
}

const childValue = {
    ...selectOption,
    paddingRight: 0,
    paddingLeft: 20,
}

const additonalValue = {
    color: colors.black,
    fontFamily: fonts.regularFont,
    fontSize: 13,
    fontStyle: "italic",
    paddingRight: 32
}


const arrowIcon: any = {
    position: "absolute",
    width: 0,
    height: 0,
    borderTop: "4px solid transparent",
    borderLeft: "9px solid #ff316d",
    borderBottom: "4px solid transparent",
    right: 15,
    top: 5

}

const optionWrapper: any = {
    position: "relative",

    ":hover": {
        background: "#fae6ee",
        cursor: "pointer"
    }
}


const crossIcon = {
    color: "#b9c6d5",
    cursor: "pointer",
    fontSize: 16,
    height: 10,
    display: "flex",
    justifyContent: "flex-end",
    margin: "4px 10px 11px 0px"
}

export {
    popoverWrapper,
    selectOption,
    selectLabel,
    tickIcon,
    optionWrapper,
    arrowIcon,
    additonalValue,
    childValue,
    crossIcon
}